import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ScriptsService } from '../services/scripts.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class ScriptDetailResolver implements Resolve<Observable<string>> {

    constructor(private scriptsService: ScriptsService) { }

    resolve(route: ActivatedRouteSnapshot) {
        if (route.paramMap.get('id') !== 'new') {
            return this.scriptsService.getScript(route.paramMap.get('id')).catch(() => {
                return Observable.of('error');
            });
          } else {
            return Observable.of('new');
          }
    }
}
